import React from 'react'
import HeroBanner from '../component/HeroBanner'
import SearchExercise from '../component/SearchExercise'

const Home = () => {
    return (
        <div>
           <HeroBanner />
           <SearchExercise />
        </div>
    )
}

export default Home